<template>
    <a  class="nav-link" href="javascript(void)" v-bind:class="'OTEventsRowTitle OTEventsRowTitle-' +  row[0]"  @click.prevent="$eventBus.$emit('event', row)"> {{ row[0] }}</a>
</template>

<script>

export default {
    props: ['row'],
}


</script>
